import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Linkedin, Mail } from 'lucide-react';

export const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="relative bg-slate-900 text-white overflow-hidden" data-testid="main-footer">
      {/* Background Image - Paraguaná */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1634818287292-61effb0df87f?w=1920&q=80" 
          alt="Paraguaná peninsula" 
          className="w-full h-full object-cover opacity-20"
          loading="lazy"
          decoding="async"
        />
      </div>
      
      <div className="relative container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & Tagline */}
          <div className="space-y-4">
            <Link to="/" data-testid="footer-logo-link">
              <img 
                src="/logo.png" 
                alt="Paraguana Hydrogen Gateway" 
                className="h-14 w-auto brightness-0 invert"
                loading="lazy"
                decoding="async"
                data-testid="footer-logo-image"
              />
            </Link>
            <p className="text-sm text-neutral-300">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">
              {t('nav.home')}
            </h3>
            <div className="space-y-2">
              <Link
                to="/potencial-energetico"
                className="block text-sm text-neutral-300 hover:text-white transition-colors"
                data-testid="footer-link-potential"
              >
                {t('nav.potential')}
              </Link>
              <Link
                to="/contacto"
                className="block text-sm text-neutral-300 hover:text-white transition-colors"
                data-testid="footer-link-contact"
              >
                {t('nav.contact')}
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">
              {t('nav.contact')}
            </h3>
            <div className="flex items-center space-x-4">
              <a href="mailto:info@paraguanah2.com" className="text-neutral-300 hover:text-white transition-colors">
                <Mail size={20} />
              </a>
              <a href="#" className="text-neutral-300 hover:text-white transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-700">
          <p className="text-xs text-neutral-400 text-center" data-testid="footer-copyright">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};